import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { loadLanguage } from 'locales/i18n';
//services
import { SettingsNavigationState } from 'services/settings/navigation';

export const useLanguage = () => {
  const queryClient = useQueryClient();
  const { i18n } = useTranslation();
  // reset menu (the quickest way to translate menu)
  const { resetDefaultNavigation } = useContext(SettingsNavigationState);

  const setLanguage = async languageCode => {
    if (i18n.language !== languageCode) {
      await loadLanguage(languageCode);
      // change language
      i18n.changeLanguage(languageCode);
      // invalidate all queries so localized values can be fetched from backend
      queryClient.invalidateQueries();
      // reset navigation so items in menu get translated
      resetDefaultNavigation();
    }
  };

  return {
    setLanguage,
  };
};
